'use strict';

angular.module('schoolLinqApp').controller('fundReportController', [
	'$scope',
	'$q',
	'authService',
	'USER_CLAIMS',
	'accountStructureService',
	function ($scope, $q, authService, USER_CLAIMS, accountStructureService) {
		var viewModel = getViewModel();
		$scope.vm = viewModel;

		$scope.loadingPromise = $q.all([getStructure($scope.vm), loadAccountTypes($scope.vm)]);

		function getViewModel() {
			var model = {
				reports: [],
				claimSections: USER_CLAIMS,
				accountStructure: [],
				accountTypes: [],
				accountTypeNames: [],
				filter: {
					report: null,
				},
				report: {
					filter: [],
				},
				errors: null,
			};

			function getAccountMask(model) {
				if (model.report.accountType) {
					switch (model.report.accountType) {
						case 'Asset':
							return model.accountStructure.AssetAccountMask;
						case 'Liability':
							return model.accountStructure.LiabilityAccountMask;
						case 'Reserve':
							return model.accountStructure.ReserveAccountMask;
						case 'Revenue':
							return model.accountStructure.RevenueAccountMask;
						case 'Expense':
							return model.accountStructure.ExpenseAccountMask;
						case 'All':
							return _.intersection(
								model.accountStructure.AssetAccountMask.split('.'),
								model.accountStructure.LiabilityAccountMask.split('.'),
								model.accountStructure.ExpenseAccountMask.split('.'),
								model.accountStructure.RevenueAccountMask.split('.'),
								model.accountStructure.ReserveAccountMask.split('.')
							).join('.');
					}
				}
				return '';
			}

			function getElementMap(model) {
				if (model.report.accountType) {
					switch (model.report.accountType) {
						case 'Asset':
							return model.accountStructure.AssetElementMap;
						case 'Liability':
							return model.accountStructure.LiabilityElementMap;
						case 'Reserve':
							return model.accountStructure.ReserveElementMap;
						case 'Revenue':
							return model.accountStructure.RevenueElementMap;
						case 'Expense':
							return model.accountStructure.ExpenseElementMap;
						case 'All':
							return _.intersection(
								model.accountStructure.AssetElementMap.split('.'),
								model.accountStructure.LiabilityElementMap.split('.'),
								model.accountStructure.ExpenseElementMap.split('.'),
								model.accountStructure.RevenueElementMap.split('.'),
								model.accountStructure.ReserveElementMap.split('.')
							).join('.');
					}
				}
				return '';
			}

			function openAccountListing(model) {
				var queries = [];

				angular.forEach(model.report.filter, function (filter) {
					angular.forEach(filter.queries, function (query) {
						queries.push(query);
					});
				});

				var report = {
					ElementQueries: queries,
				};

				reportHelper.getReport($scope, '/api/account/accountlistingreport', report, 'AccountListingReport.pdf');
			}

			return angular.extend(model, {
				getAccountMask: _.partial(getAccountMask, model),
				getElementMap: _.partial(getElementMap, model),
				openAccountListing: _.partial(openAccountListing, model),
			});
		}

		function getStructure(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingStructure, model));

			function finishLoadingStructure(model, response) {
				model.accountStructure = response.data.accountStructure;
				return angular.noop;
			}
		}

		function loadAccountTypes(model) {
			return accountStructureService.getAccountTypes().then(_.partial(finishLoadingAccountTypes, model));

			function finishLoadingAccountTypes(model, response) {
				model.accountTypes = response.data.accountTypes;
				model.accountTypes.unshift({ Id: 0, Description: 'All' });
				model.accountTypeNames = _.map(model.accountTypes, function (type) {
					return type.Description;
				});
				return angular.noop;
			}
		}
	},
]);
